export default (zip) => {
  if(zip) {
    if(zip.length > 5 && zip.indexOf('-') < 0) {
      zip = zip.slice(0, 5) + '-' + zip.slice(5);
    }
  }
  return zip;
};